import { LotacaoProfissional } from '../ProfissionalAcessosView'

export function getInconsistenciasLotacaoAgendaOnline(lotacao: LotacaoProfissional) {
  const inconsistencias = !lotacao.ativo
    ? 'Lotação inativa'
    : !lotacao.importada
    ? 'Lotação não registrada no CNES'
    : !lotacao.hasConfiguracaoAgenda
    ? 'Lotação não possui uma configuração de agenda'
    : lotacao.equipe &&
      (lotacao.equipe.tipoEquipe.descricao === 'EMAD' || lotacao.equipe.tipoEquipe.descricao === 'EMAP')
    ? 'Lotação de Atenção Domiciliar não permite agendamento online'
    : !lotacao.equipe || lotacao.equipe.tipoEquipe.descricao !== 'AB'
    ? 'Lotação não possui INE cadastrado'
    : ''

  return inconsistencias
}
